import { render } from "./NykBanner.vue?vue&type=template&id=67f7a27c"
import script from "./NykBanner.vue?vue&type=script&lang=js"
export * from "./NykBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__